import {
  ADD_POI,
  ADD_POI_CATEGORIES,
  ADD_POI_SUB_CATEGORIES,
  GET_POI,
  GET_POI_CATEGORIES,
  GET_POI_SUB_CATEGORIES,
  GET_POI_SUB_TYPE,
  GET_POI_TYPE,
  UPDATE_POI_CATEGORIES_STATUS,
  UPDATE_POI_ICON,
  UPDATE_POI_STATUS,
  UPDATE_POI_SUB_CATEGORIES_STATUS,
} from "../actions/types";

const initialState = { PoiList: [] };

const PoiCategoryReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_POI_CATEGORIES:
      return {
        ...state,
        PoiList: payload,
      };
    case ADD_POI_CATEGORIES:
      return {
        ...state,
        response: payload,
      };
    case GET_POI_SUB_CATEGORIES:
      return {
        ...state,
        SubPoiList: payload,
      };
    case ADD_POI_SUB_CATEGORIES:
      return {
        ...state,
        response: payload,
      };
    default:
      return state;
  }
};
const PoiReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_POI:
      return {
        ...state,
        PoiList: payload,
      };
    case ADD_POI:
      return {
        ...state,
        response: payload,
      };
    default:
      return state;
  }
};

const updatePoiStatusReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_POI_CATEGORIES_STATUS:
      return {
        ...state,
        satusResponse: payload,
      };
    case UPDATE_POI_SUB_CATEGORIES_STATUS:
      return {
        ...state,
        subSatusResponse: payload,
      };
    default:
      return state;
  }
};

const updateMainPoiStatusReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_POI_STATUS:
      return {
        ...state,
        satusResponse: payload,
      };
    default:
      return state;
  }
};
const poiCategoryDropdownReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_POI_TYPE:
      return {
        ...state,
        response: payload,
      };
    case GET_POI_SUB_TYPE:
      return {
        ...state,
        subResponse: payload,
      };
    default:
      return state;
  }
};

const updatePoiIconReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_POI_ICON:
      return {
        ...state,
        poiIcon: payload,
      };
    default:
      return state;
  }
};

export {
  PoiCategoryReducer,
  updatePoiStatusReducer,
  updateMainPoiStatusReducer,
  PoiReducer,
  poiCategoryDropdownReducer,
  updatePoiIconReducer,
};
